// Angular
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'default'
})

export class DefaultPipe implements PipeTransform {
    transform(value: string, defaultValue: string = '--'): string {
        if (typeof(value) === 'string') {
            value = value.trim();
        }

        return value ? value : defaultValue;
    }
}
